import Scrollbars from 'react-custom-scrollbars-2';
import { Link } from 'react-router-dom';

import BuyRMVControl from 'components/buyRMVControl/BuyRMVControl';
import FreeRMVControl from 'components/freeRMVControl/FreeRMVControl';
import MenuToggle from 'components/menu/menuToggle/MenuToggle';
import MenuWalletButton from 'components/menu/menuWalletButton/MenuWalletButton';
import SocialMediaAndLinks from 'components/menu/mobileHeader/socialMediaAndLinks/SocialMediaAndLinks';

import RealityLogo from 'assets/logos/rda_logo.png';

import styles from './Header.module.scss';
import HeaderNavigation from './HeaderNavigation';

interface HeaderMobileProps {
  menuVisible: boolean;
  mapPageDisabled: boolean;
  mapUrl: string;
  variant?: 'default' | 'referral';
  onToggleMenu: () => void;
  onCloseMenu: () => void;
  onMapDisabledClick: () => void;
}

const HeaderMobile = ({
  menuVisible,
  mapPageDisabled,
  mapUrl,
  variant = 'default',
  onToggleMenu,
  onCloseMenu,
  onMapDisabledClick,
}: HeaderMobileProps) => {
  return (
    <>
      <div className={`${styles['menu__mobile-social']} ${styles[`menu__mobile-social--${variant}`]}`}>
        {/* Hamburger Toggle */}
        <button
          id="header-mobile-menu-toggle"
          className={`button--styleless ${styles['menu-toggle']} ${menuVisible ?? styles['menu-toggle--collapsed']}`}
          onClick={onToggleMenu}
          aria-label="Open navigation menu"
          aria-expanded={menuVisible}
          aria-controls="header-mobile-nav"
        >
          <MenuToggle isActive={menuVisible} />
        </button>

        {/* Logo (Centered) */}
        <div className={styles['menu__logo']}>
          <Link to="/" aria-label="Landing page">
            <span className="avatar">
              <img src={RealityLogo} alt="RealityDA" />
            </span>
          </Link>
        </div>

        {/* Slide-out Navigation Drawer */}
        <nav
          id="header-mobile-nav"
          className={`${styles['nav']} ${styles['nav--mobile']} ${styles[`nav--${variant}`]} ${
            menuVisible ? styles['nav--expanded'] : ''
          }`}
          aria-label="Main navigation"
          aria-hidden={menuVisible ? undefined : true}
        >
          <Scrollbars
            style={{ width: '100%', height: '100%' }}
            renderThumbVertical={() => <div style={{ display: 'none' }} />}
            renderTrackVertical={() => <div style={{ display: 'none' }} />}
          >
            <div className={styles['mobile-menu-content']}>
              {/* Top section: Navigation items + Buttons */}
              <div className={styles['mobile-menu__top']}>
                {/* Navigation items */}
                <div className={styles['mobile-menu__nav']}>
                  <ul className={styles['mobile-nav-list']}>
                    <HeaderNavigation
                      mapPageDisabled={mapPageDisabled}
                      mapUrl={mapUrl}
                      onMapDisabledClick={onMapDisabledClick}
                      variant={variant}
                    />
                  </ul>
                </div>

                {/* Action buttons */}
                <div className={styles['mobile-menu__buttons']}>
                  <BuyRMVControl sourceScreen="hamburger_menu" />
                  <FreeRMVControl variant={variant} />
                </div>
              </div>

              {/* Bottom section: Social + Footer */}
              <SocialMediaAndLinks />
            </div>
          </Scrollbars>
        </nav>

        {/* Wallet Button (Right) */}
        <MenuWalletButton variant={variant} />
      </div>

      {/* Backdrop Overlay */}
      {menuVisible && <div className={styles['nav__backdrop']} onClick={onCloseMenu} aria-hidden="true" />}
    </>
  );
};

export default HeaderMobile;
